module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.packages != null && _vm.packages.length > 0) ? _c('div', _vm._l((_vm.packages), function(package) {
    return (package.ranges.length > 0) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
    }, [_c('div', {
      staticClass: "box-layout-inner"
    }, [_c('div', {
      staticClass: "title-block"
    }, [_vm._v("\n                " + _vm._s(package.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "content-block hidden-xs",
      domProps: {
        "innerHTML": _vm._s(package.description)
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "content-links"
    }, _vm._l((package.ranges), function(range) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.progress(range, package)
          }
        }
      }, [_vm._v(_vm._s(range.title))])])
    }))])]) : _vm._e()
  })) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [(_vm.loading) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-5x dark"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-488aa788"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/builder/AgeRanges.vue
// module id = 172
// module chunks = 0